<script>
    export default {
        props: {
            isLoading: [Number, Boolean],
            disabled: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'submit'
            },
            btnClass: {
                type: String,
                default: 'btn btn-outline-primary'
            },
            text: {
                type: String,
                default: 'Save'
            }
        }
    };
</script>

<template>
    <button :type="type" :class="btnClass" :disabled="!!isLoading || disabled">
        <span v-show="!!isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
        <span>{{ isLoading ? 'Loading...' : text }}</span>
    </button>
</template>
